<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <p class="title text-xs-center">Add New Network</p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :rules="[v => !!v || 'Network name is required']"
            label="Network Name"
            required
          ></v-text-field>
          
          <v-text-field
            v-model="clickIdParameter"
            :rules="[v => !!v || 'clickId Parameter is required']"
            label="Click Id Parameter"
            required
          ></v-text-field>

          <v-text-field
            v-model="postbackUrl"
            :rules="[v => !!v || 'Please provide postback url.']"
            label="Postback Url"
            required
          ></v-text-field>

          <v-text-field
            type="number"
            v-model="filter"
            label="Filter"
          ></v-text-field>

          <v-checkbox
            v-model="status"
            :rules="[v => !!v || 'Please check the box to make network active.']"
            label="Do you want to make it active?"
            required
          ></v-checkbox>
          <div class="text-xs-center">
          <v-btn @click="clear">clear</v-btn>
          <v-btn
            color="primary"
            :disabled="!valid"
            @click="submit"
          >
            submit
          </v-btn>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
  import axios from 'axios'
  import { SERVER_URL } from './../../constant.js'

  export default {
    data: () => ({
      valid: true,
      name: '',
      clickIdParameter: '',
      postbackUrl: '',
      filter: 50,
      status: false
    }),
    created () {
      document.title = 'Add Network';
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          axios.post(`${SERVER_URL}/network/add`, {
            name: this.name,
            clickIdParameter: this.clickIdParameter,
            postbackUrl: this.postbackUrl,
            filter: this.filter,
            status: this.status
          }).then(res => {
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Network Added Successfully'})
            document.dispatchEvent(showSnackbarEvent)
            this.$refs.form.reset()
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/network/AddNetwork.vue